<script>
export default {
  name: "ubahnsVue",
  data() {
    return {
      geojsonFeature: {
        type: "FeatureCollection",
        name: "ubahn",
        crs: {
          type: "name",
          properties: {
            name: "urn:ogc:def:crs:OGC:1.3:CRS84",
          },
        },
        features: [
          {
            type: "Feature",
            properties: {
              name: "Milbertshofen U-Bahn Station",
            },
            geometry: {
              type: "Point",
              coordinates: [11.573304287678688, 48.180800722504323, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Olympiazentrum U-Bahn Station",
            },
            geometry: {
              type: "Point",
              coordinates: [11.556277802141476, 48.178868596665801, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Scheidplatz U-Bahn Station",
            },
            geometry: {
              type: "Point",
              coordinates: [11.573153506356542, 48.171226729639777, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Petuelring U-Bahn Station",
            },
            geometry: {
              type: "Point",
              coordinates: [11.566456603642676, 48.175227964066551, 0.0],
            },
          },
        ],
      },
    };
  },
};
</script>
